import React, { useEffect } from 'react';
import { Crewmate, CrewmateColor } from './Crewmate';

interface FloatingCrewmateData {
  color: CrewmateColor;
  delay: number;
  side: 'left' | 'right';
  top: string;
}

const floatingCrewmates: FloatingCrewmateData[] = [
  { color: 'red', delay: 0, side: 'left', top: '10%' },
  { color: 'blue', delay: 2, side: 'right', top: '20%' },
  { color: 'green', delay: 4, side: 'left', top: '60%' },
  { color: 'pink', delay: 6, side: 'right', top: '70%' },
  { color: 'orange', delay: 8, side: 'left', top: '40%' },
  { color: 'yellow', delay: 10, side: 'right', top: '30%' }
];

export const FloatingCrewmates: React.FC = () => {
  useEffect(() => {
    // Initialize floating animations with staggered delays
    const crewmates = document.querySelectorAll('.floating-crewmate');
    
    crewmates.forEach((crewmate, index) => {
      const data = floatingCrewmates[index];
      if (data) {
        const element = crewmate as HTMLElement;
        element.style.animationDelay = `${data.delay}s`;
        
        // Add random vertical position variation
        const randomOffset = Math.random() * 20 - 10; // ±10%
        const topValue = parseInt(data.top) + randomOffset;
        element.style.top = `${Math.max(5, Math.min(85, topValue))}%`;
        
        // Set initial position based on side
        if (data.side === 'left') {
          element.style.left = '-100px';
          element.style.right = 'auto';
        } else {
          element.style.right = '-100px';
          element.style.left = 'auto';
          // Reverse animation for right-side crewmates
          element.style.animationDirection = 'reverse';
        }
      }
    });
  }, []);

  return (
    <div className="floating-crewmates">
      {floatingCrewmates.map((data, index) => (
        <Crewmate
          key={index}
          color={data.color}
          size="medium"
          className="floating-crewmate"
          style={{
            position: 'absolute',
            animation: 'float 20s infinite ease-in-out'
          }}
        />
      ))}
    </div>
  );
};